<template>
  <b-card title="Minimum Quantity Multiplier">
    <minimum-quantity-filter @filtersUpdated="filtersChangeHandler" />
    <minimum-quantity-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import MinimumQuantityList from '@/components/Stock/MinimumQuantity/MinimumQuantityTable.vue'
import MinimumQuantityFilter from '@/components/Stock/MinimumQuantity/MinimumQuantityFilter.vue'

export default {
  components: {
    BCard,
    MinimumQuantityList,
    MinimumQuantityFilter,
  },
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}

</script>
